﻿<fieldset class="no-legend">
  <div class="column-100">
    <label class="required">Datum</label>
    <div class="input"><input type="text" pick-a-date [(ngModel)]="data.paymentInstructionDate" [maxToday]="true"/></div>
  </div>
</fieldset>
